import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import helpersTime from "../../../helpers/time";
import helpersNumbers from "../../../helpers/numbers";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import moment from "moment";
import TitleBar from "../../partials/content/TitleBar";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function AllIndependentPositionsSitePublisher({
  startDate,
  endDate,
  dataSitePublisher,
  addPositionTagToState,
  position_added_in_edit_action,
  addedPositionInEditAction,
  typeAction,
  render,
}) {
  const params = useParams();
  const sitePublisherID = parseInt(params.id);
  const pageID = 0;
  const pageTitle = process.env.REACT_APP_TITLE_INDEPENDENT_PAGE;
  const [positions, setPositions] = useState([]);
  const [imageSrc, setImageSrc] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();
  const history = useHistory();

  useEffect(() => {
    const initDataComponent = async () => {
      await getSitePublisher();
      await getImageIndependentSitePublisher();
      await getIndependentPositions();
      scrollForSeeMessage();
    };
    initDataComponent();
  }, []);

  const scrollForSeeMessage = () => {
    const element = document.querySelector("#select-position-container");
    element.scrollIntoView();
  };

  const getImageIndependentSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const image = await sendRequestGetImageIndependentPositionsSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!image) {
      return;
    }

    setImageSrc(image.src);
  };

  const sendRequestGetImageIndependentPositionsSitePublisher = async (
    sitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let image;
    try {
      image = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/position/image-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return image.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitePublisher) {
      return;
    }
    setSitePublisherData(sitePublisher);
  };

  const sendRequestGetSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const getIndependentPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const independentPositions = await sendRequestGetIndependentPositions(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!independentPositions) {
      return;
    }

    setPositions(independentPositions);
  };

  const sendRequestGetIndependentPositions = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let independentPositions;
    try {
      independentPositions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/position/all-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return independentPositions.data.data;
  };

  const hasPositionEmptyCampaignBanner = (position) => {
    const newPendingCampaigns =
      getCampaignBannerThatOverrideCampaignDateWithDateGroup(position);
    if (position.count > newPendingCampaigns.length) {
      return true;
    }

    return false;
  };

  const getCampaignBannerThatOverrideCampaignDateWithDateGroup = (position) => {
    const startDateGroup = helpersTime.convertJalaliToGregorian(startDate);
    const endDateGroup = helpersTime.convertJalaliToGregorian(endDate);

    let newCampaigns = [];
    let activeCampaigns = position.active;
    for (const key in activeCampaigns) {
      const pendingActive = activeCampaigns[key];
      const startDateCampaign = pendingActive.start_date;
      const endDateCampaign = pendingActive.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingActive);
      }
    }

    let pendingCampaigns = position.pending;
    for (const key in pendingCampaigns) {
      const pendingCampaign = pendingCampaigns[key];
      const startDateCampaign = pendingCampaign.start_date;
      const endDateCampaign = pendingCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingCampaign);
      }
    }
    return newCampaigns;
  };

  const generateCheckBoxAddPositionTag = (
    position,
    isChecked,
    addPositionToState
  ) => {
    if (
      isChecked === "checked" &&
      typeAction === typeActionCategoryUserSitePublisher.EDIT &&
      !position_added_in_edit_action.includes(position.tag_html_id)
    ) {
      return;
    }
    return (
      <label className="adl-switch">
        <input
          type="checkbox"
          defaultChecked={isChecked}
          onChange={(e) => {
            addPositionToState(position);
          }}
        />
        <span className="adl-slider round"></span>
      </label>
    );
  };

  const addPositionToState = (position) => {
    const positionsPrice = position.price;

    addPositionTagToState({
      site_publisher_url: sitePublisherData.url.replace("http://", ""),
      web_site_publisher_id: sitePublisherID,
      page_id: pageID,
      page_title: pageTitle,
      position_tag_html_id: position.tag_html_id,
      position_price: positionsPrice,
      position_base_price: position.base_price,
      position_count: position.count,
      position_size: position.size,
    });

    if (typeAction === typeActionCategoryUserSitePublisher.EDIT) {
      addedPositionInEditAction({
        position: position.tag_html_id,
      });
    }
  };

  const generatePositionsPageSitePublisher = () => {
    return (
      <>
        <div>
          <div className="col-12 pt-2">
            <div className="alert alert-warning ">
              <p>
                <i className="fa fa-info pl-2"></i>
                توجه داشته باشید :{" "}
              </p>
              <ul className="pr-3">
                <li>
                  <p>
                    در تصویر زیر میتوانید جایگاه های تبلیغاتی هایلات را در صفحه
                    مدنظر مشاهده نمایید.
                  </p>
                </li>
                <li>
                  <p>
                    جایگاه های قرمز به معنای رزور شدن توسط کمپین کاربران است.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div>
          <span>مبلغ این صفحه =</span>
          <span className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(getPricePage())
            )}
          </span>
          <span className="pr-2">تومان</span>
        </div>
        <div className="container-fluid">
          <div className="row">
            {positions.map((position, index) => {
              const isPositionEmptyCampaignBanner =
                hasPositionEmptyCampaignBanner(position);

              let isChecked = "";

              if (dataSitePublisher[sitePublisherID] !== undefined) {
                if (dataSitePublisher[sitePublisherID][pageID] !== undefined) {
                  if (
                    dataSitePublisher[sitePublisherID][
                      pageID
                    ].positions.includes(position.tag_html_id)
                  ) {
                    isChecked = "checked";
                  }
                }
              }

              let classBgPosition = "";
              if (isPositionEmptyCampaignBanner) {
                if (isChecked === "checked") {
                  classBgPosition = "bg-success";
                }
              } else {
                classBgPosition = "bg-danger";
              }

              return (
                <>
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
                  >
                    <div className={classBgPosition}>
                      <div className="p-2 d-flex">
                        <div className="position-absolute">
                          <span>
                            {isPositionEmptyCampaignBanner === true ? (
                              generateCheckBoxAddPositionTag(
                                position,
                                isChecked,
                                addPositionToState
                              )
                            ) : (
                              <></>
                            )}
                          </span>
                        </div>
                        <div className="align-items-center justify-content-center d-flex flex-grow-1">
                          <span>اطلاعات جایگاه</span>
                          <span className="px-2">-</span>
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(position.id)}
                          </span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          اندازه
                        </div>
                        <div className="py-2 w-50 text-center">
                          <span
                            className="letter-spacing-finance-number"
                            dir="ltr"
                          >
                            {helpersNumbers.toPersianNum(
                              position.size.replace("-", "×")
                            )}
                          </span>
                          <span className="pr-2">پیکسل</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ظرفیت کل
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(position.count)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>
                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم شما
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(1)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ارزش کل
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.base_price
                              )
                            )}
                          </span>
                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          پرداختی شما
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.price
                              )
                            )}
                          </span>

                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className="px-2 d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم نمایش
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              Math.floor((1 / position.count) * 100)
                            )}
                          </span>
                          <span className="pr-2">درصد</span>
                        </div>
                      </div>

                      <div dir="ltr" className="p-2 text-center border-top">
                        {position.tag_html_id}
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <span
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
          }}
          className="btn btn-success"
        >
          ذخیره و بازگشت
        </span>
        <div className="form-group pt-2">
          <div>
            <a href={imageSrc} target="_blank">
              <img className="border border-success img-fluid" src={imageSrc} />
            </a>
          </div>
        </div>
      </>
    );
  };

  const checkDataExisiForcalculateAmountThisPage = () => {
    if (pageID === undefined) {
      return false;
    }

    if (sitePublisherData === undefined) {
      return false;
    }

    if (positions.length === 0) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID] === undefined) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID][pageID] === undefined) {
      return false;
    }

    if (dataSitePublisher[sitePublisherID][pageID].positions.length === 0) {
      return false;
    }
    return true;
  };

  const getPricePage = () => {
    if (!checkDataExisiForcalculateAmountThisPage()) {
      return 0;
    }
    return dataSitePublisher[sitePublisherID][pageID].price;
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <>
        <div className="text-left">
          <div
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
            className="btn btn-primary"
          >
            <span>بازگشت</span>
            <span className="pr-2">
              <i class="fas fa-arrow-left"></i>
            </span>
          </div>
        </div>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img src="/assets/img/do-not-have-position.svg" />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p>این سایت هیچ جایگاهی مستقلی ندارد.</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar
          title={` جایگاه های مستقل سایت
          ${sitePublisherData?.url.replace("http://", "")}`}
        />

        <section className="content pt-5">
          <div className="card" id="select-position-container">
            <div className="card-body">
              {positions.length !== 0
                ? generatePositionsPageSitePublisher(positions)
                : generatePageDoseNotHaveAnyPositions()}
            </div>
          </div>
        </section>
      </div>

      <ExportFileExcelButton />
      <PreviewPositionsGroupSitePublisher />
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addPositionTagToState: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_POSITION,
        payload: action,
      });
    },
    addedPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.POSITION_ADDED_IN_EDIT_ACTION,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    typeAction: state.categoryUserSitePublisher.type_action,
    position_added_in_edit_action:
      state.categoryUserSitePublisher.position_added_in_edit_action,
    render: state.categoryUserSitePublisher.render,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllIndependentPositionsSitePublisher);
